import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-segmented-control]')) return;

  addEventListeners();
}

function addEventListeners() {
  const segmentedControls = $$('[data-au-segmented-control]');

  segmentedControls.forEach((segControl) => {
    segControl.addEventListener('click', (e) => {
      const input = e.currentTarget.querySelector('input');

      if (input) {
        const isCheckbox = input.type === 'checkbox';
        const isChecked = e.target === input ? input.checked === false : input.checked === true;

        if (isCheckbox && isChecked) {
          input.checked = false;
        } else {
          input.checked = true;
        }

        handleTargetVisibility(input);
      }

      handleDatalayer(e.currentTarget);
    });
  });
}

function handleDatalayer(segControl) {
  const group = segControl.closest('[data-au-segmented-control-group]');

  if (!group || !group.hasAttribute('data-au-segmented-control-group-default')) return;

  const groupTitleEl = group.querySelector('[data-au-segmented-control-group-title]');
  const titleText = groupTitleEl
    ? groupTitleEl.innerText
    : segControl.closest('section')?.querySelector('[data-au-heading-title]')?.innerText || '';

  const clickTitleEl = segControl.querySelector('[data-au-segmented-control-title]');
  const clickText = clickTitleEl ? clickTitleEl.innerText : '';

  const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickTab',
    item_id,
  });
}

function handleTargetVisibility(input) {
  if (input.type !== 'radio' || !input.checked) return;

  const group = input.closest('[data-au-segmented-control-group]');
  if (!group) return;

  const container = group.closest('[data-au-segmented-control-container]') || group.parentElement;
  const targets = container.querySelectorAll('[data-au-segmented-control-target]');

  if (!targets.length) return;

  const value = input.value;

  targets.forEach((target) => {
    const targetValue = target.getAttribute('data-au-segmented-control-target');
    const isMatch = targetValue === value;

    target.classList.toggle('au-active', isMatch);
    target.classList.toggle('au-hide', !isMatch);
  });
}

export default { init };
